var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('history-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"historyData":_vm.historyData,"paginationData":_vm.paginationData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }